export default __webpack_public_path__ + "static/media/espresso in flowers.763223da.jpg";